import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '@/lib/firebase';

/**
 * Firebase Auth uid that updates on auth state changes.
 * Use when Zustand `firebaseUser` can lag behind `auth.currentUser` after OAuth / resume.
 */
export function useAuthUid(): string | undefined {
  const [uid, setUid] = useState<string | undefined>(() => auth.currentUser?.uid ?? undefined);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setUid(user?.uid);
    });
    return unsub;
  }, []);

  return uid;
}
